import { createFileRoute } from "@tanstack/react-router";

import BehaviourStudio from "../pages/Rules";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/behavior/banners")({
  component: BehaviourBannersRoute,
});

function BehaviourBannersRoute() {
  return (
    <RequireAuth page="behaviourStudio">
      <BehaviourStudio />
    </RequireAuth>
  );
}
